import { NAVIGATION_CHANGE } from '../constants/actionTypes';

export const initialState = [];

const excludedPaths = ['/login', '/signin-callback.html'];

const navigation = (state = initialState, action) => {
  const { type, path } = action;

  if (type === NAVIGATION_CHANGE) {
    if (excludedPaths.includes(path)) {
      return initialState;
    }

    const pathIndex = state.indexOf(path);
    if (pathIndex === -1) {
      return [...state, path];
    }

    return state.slice(0, pathIndex + 1);
  }

  return state;
};

export default navigation;
